var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3342 1.16637L6.66726 5.83327L2.00036 1.16637C1.67834 0.844352 1.15623 0.843769 0.833631 1.16637C0.511031 1.48897 0.511614 2.01108 0.833631 2.33309L5.50054 7L0.833631 11.6669C0.511031 11.9895 0.511615 12.5116 0.833631 12.8336C1.15565 13.1556 1.67776 13.1562 2.00036 12.8336L6.66726 8.16673L11.3342 12.8336C11.6562 13.1556 12.1783 13.1562 12.5009 12.8336C12.8235 12.511 12.8229 11.9889 12.5009 11.6669L7.83399 7L12.5009 2.33309C12.8235 2.01049 12.8229 1.48838 12.5009 1.16637C12.1789 0.844351 11.6568 0.843768 11.3342 1.16637Z",
    fill: "#808A97",
    stroke: "#808A97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.35a72affaa97418a51b01c37fba945bc.svg";
export { ForwardRef as ReactComponent };